/**
 * Очищает email-адрес от некорректных символов
 * @param email - email адрес для очистки
 * @returns очищенный email адрес
 */
export function cleanEmail(email: string): string {
    if (!email) {
        return "";
    }
    
    // Удаляем все пробельные символы
    email = email.replace(/\s+/g, '');
    
    // Приводим к нижнему регистру
    email = email.toLowerCase();
    
    // Находим первый @ для разделения на локальную и доменную части
    const parts = email.split('@');
    if (parts.length < 2) {
        return email;
    }
    
    // Берем первую часть как локальную и объединяем остальные как доменную
    const localPart = parts[0];
    const domainParts = parts.slice(1).filter(p => p);
    if (!domainParts.length) {
        return localPart + '@';
    }
    
    // Проверяем, была ли точка в начале домена
    const hadLeadingDot = parts[1].startsWith('.');
    
    // Очищаем локальную часть от недопустимых символов
    // Разрешены: a-z, 0-9, ., _, +, -, !
    const localAllowedChars = new Set('abcdefghijklmnopqrstuvwxyz0123456789._+-');
    const cleanedLocalPart = Array.from(localPart)
        .filter(c => localAllowedChars.has(c))
        .join('');
    
    // Объединяем все части домена
    const domainPart = domainParts.join('.');
    
    // Очищаем доменную часть
    // Разрешены только: a-z, 0-9, -, .
    const domainAllowedChars = new Set('abcdefghijklmnopqrstuvwxyz0123456789-.');
    let cleanedDomainPart = Array.from(domainPart)
        .filter(c => domainAllowedChars.has(c))
        .join('');
    
    // Удаляем точки и дефисы в конце домена
    cleanedDomainPart = cleanedDomainPart.replace(/[.-]+$/, '');
    
    // Заменяем множественные точки на одну
    cleanedDomainPart = cleanedDomainPart.replace(/\.+/g, '.');
    
    // Удаляем точку в начале домена, если её не было изначально
    if (!hadLeadingDot) {
        cleanedDomainPart = cleanedDomainPart.replace(/^\.+/, '');
    }
    
    // Собираем email обратно
    return `${cleanedLocalPart}@${cleanedDomainPart}`;
} 